import { render, staticRenderFns } from "./EvidenceArchive.vue?vue&type=template&id=afac4f5a&"
import script from "./EvidenceArchive.vue?vue&type=script&lang=js&"
export * from "./EvidenceArchive.vue?vue&type=script&lang=js&"
import style0 from "./EvidenceArchive.vue?vue&type=style&index=0&id=afac4f5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports